module.exports = __webpack_public_path__ + "769e5c031417f96b3242122b8cce90de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-female-5.svg
// module id = 86
// module chunks = 0